export const SENTRY_DSN =
  'https://e9f5db832dae673130154e00d0560eb5@o506518.ingest.us.sentry.io/4508339957923840';

// If the log pollute the Sentry platform, it will be reduced
export const SENTRY_SAMPLE_RATE = 1.0;

export const SENTRY_ENV = (() => {
  if (process.env.ENV === 'local') {
    return 'dev';
  }

  return process.env.ENV || 'dev';
})();
